import ability from "@/libs/acl/ability";

const getUserData = () => JSON.parse(localStorage.getItem('userData')) || null;

// 動態權限檢查函數，每次調用時都重新檢查當前權限狀態
const dynamicAbilityCan = (action, resource) => {
  try {
    // 確保 ability 實例存在且有 can 方法
    if (!ability || typeof ability.can !== 'function') {
      console.warn('Ability 實例未正確初始化');
      return false;
    }

    // 檢查 ability 是否有規則
    if (!ability.rules || ability.rules.length === 0) {
      console.warn('Ability 實例沒有權限規則');
      return false;
    }

    const result = ability.can(action, resource);
    console.log(`權限檢查: ${action} on ${resource} = ${result}`);
    return result;
  } catch (error) {
    console.warn('權限檢查失敗:', error);
    return false;
  }
};

// 將選單配置改為函數，確保每次獲取時都重新計算權限
const getNormalMenuItems = () => [
  {
    title: "儀表板(Dashboard)",
    route: "home",
    icon: "HomeIcon",
    resource: 'dashboard',
    action: 'read',
  },
  // {
  //   title: "師傅管理(Workers)",
  //   route: "",
  //   icon: "UserPlusIcon",
  //   children: [
      {
        title: "師傅資料",
        route: "workers-list",
        icon: "ToolIcon",
        resource: 'workers',
        action: 'read',
      },
      // {
      //   title: "用戶預支記錄",
      //   route: "worker-advance-payment-list",
      //   resource: 'user_prepayments',
      //   action: 'read',
      // },
      // {
      //   title: "用戶報銷資料",
      //   route: "worker-claim-list",
      //   resource: 'user_claims',
      //   action: 'read',
      // },
      // {
      //   title: "工資記錄",
      //   route: "worker-salary-list",
      //   resource: 'user_salaries',
      //   action: 'read',
      // },
      // {
      //   title: "進度資料",
      //   route: "progress-list",
      //   resource:'progresses',
      //   action:'read',
      // },
  //   ],
  // },
  {
    title: "項目資料",
    icon: "ListIcon",
    route: "projects-list",
    resource: 'projects',
    action: 'read',
  },
  // {
  //   title: "項目管理",
  //   route: "",
  //   icon: "ListIcon",
  //   children: [
  //     {
  //       title: "項目資料",
  //       route: "projects-list",
  //       resource: 'projects',
  //       action: 'read',
  //     },
      // {
      //   title: "客戶/訂單資料",
      //   route: "order-list",
      //   resource: 'orders',
      //   action: 'read',
      // },
  //   ],
  // },
  {
    title: "商品管理",
    route: "products-list",
    icon: "PackageIcon",
    resource: 'products',
    action: 'read',
  },
  {
    title: "報價單",
    route: "quotations-list",
    icon: "ClipboardIcon",
    // 使用函數進行動態權限檢查，支援多個權限
    resource: () => {
      return dynamicAbilityCan('read', 'quotations') ||
             dynamicAbilityCan('read_all', 'quotations')
             ? 'Auth' : 'XX';
    },
    action: 'read',
  },
  {
    title: "發票及收據系統",
    route: "",
    icon: "FileTextIcon",
    children: [
      {
        title: "發票",
        route: "invoices-list",
        // 使用函數進行動態權限檢查，支援多個權限
        resource: () => {
          return dynamicAbilityCan('read', 'invoices') ||
                 dynamicAbilityCan('read_all', 'invoices')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      {
        title: "收據",
        route: "receipts-list",
        // 使用函數進行動態權限檢查，支援多個權限
        resource: () => {
          return dynamicAbilityCan('read', 'receipts') ||
                 dynamicAbilityCan('read_all', 'receipts')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      {
        title: "退款",
        route: "refunds-list",
        // 使用函數進行動態權限檢查，支援多個權限
        resource: () => {
          return dynamicAbilityCan('read', 'refunds') ||
                 dynamicAbilityCan('read_all', 'refunds')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
    ],
  },
  {
    title: "財務",
    route: "",
    icon: "DollarSignIcon",
    children: [
      // {
      //   title: "審批薪金支出",
      //   route: "approval-expenditure-list",
      //   resource:'expenditure',
      //   action:'read',
      // },
      {
        title: "預支記錄",
        route: "advance-payment-list",
        resource: 'prepayments',
        action: 'read',
      },
      {
        title: "薪金支出記錄",
        route: "expenditures-list",
        resource: 'expenditures',
        action: 'read',
      },
      {
        title: "報銷記錄",
        route: "claim-list",
        resource: 'claims',
        action: 'read',
      },
      {
        title: "壞賬記錄",
        route: "bad-debt-list",
        resource: 'bad_debts',
        action: 'read',
      },  
      {
          title: "工資記錄",
          route: "salaries-list",
          resource: 'salaries',
          action: 'read',
        },
      {
        title: "銀行進支記錄",
        route: "bank-records-list",
        resource: 'bank_records',
        action: 'read',
      },
      {
        title: "折扣卷管理",
        route: "coupons-list",
        // 使用函數進行動態權限檢查
        resource: () => {
          return dynamicAbilityCan('read', 'coupons') ||
                 dynamicAbilityCan('read', 'gift_vouchers') ||
                 dynamicAbilityCan('read', 'reservation_voucher') ||
                 dynamicAbilityCan('read', 'collection_voucher')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
    ],
  },
  // {
  //   title: "商品銷售報告",
  //   route: "report",
  //   icon: "BarChartIcon",
  //   resource: 'Auth',
  //   action: 'read',
  // },
  // {
  //   title: "分析系統",
  //   route: "analysis-chart",
  //   icon: "BarChartIcon",
  //   resource: 'Auth',
  //   action: 'read',
  // },
  {
    title: "供應商帳單列表",
    route: "supplier-documents-list",
    icon: "FileTextIcon",
    resource: 'staff_supplier_documents',
    action: 'read',
  },
  {
    title: "供應商(埋數用)",
    route: "staff-supplier-list",
    icon: "BriefcaseIcon",
    resource: 'staff_suppliers',
    action: 'read',
  },
  {
    title: "修改記錄",
    route: "edit-records-list",
    icon: "EditIcon",
    resource: 'edit_records',
    action: 'read',
  },
  {
    title: "訊息記錄",
    route: "messages-list",
    icon: "BellIcon",
    resource: 'messages',
    action: 'read',
  },
  {
    title: "設置(Setting)",
    route: "",
    icon: "SettingsIcon",
    children: [
      {
        title: "用戶資料管理",
        route: "users-list",
        // 使用函數進行動態權限檢查
        resource: () => {
          return dynamicAbilityCan('read', 'setting_customers') ||
                 dynamicAbilityCan('read', 'setting_staffs') ||
                 dynamicAbilityCan('read', 'setting_suppliers')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      {
        title: "用戶權限管理",
        route: "roles-list",
        resource: 'setting_roles',
        action: 'read',
      },
      {
        title: "用戶頭像管理",
        route: "avatars-list",
        resource: 'setting_avatar',
        action: 'read',
      },
      {
        title: "客戶需知管理",
        route: "announcement",
        resource: 'settings_announcement',
        action: 'read',
      },
      {
        title: "外部連結管理",
        route: "redirect-url",
        resource: 'settings_redirect_url',
        action: 'read',
      },
      {
        title: "模版管理",
        route: "receipt-format-list",
        resource: 'settings_receipt_format',
        action: 'read',
      },
      {
        title: "蓋章管理",
        route: "stamps-list",
        resource: 'settings_stamp',
        action: 'read',
      },
      {
        title: "發票單據備註管理",
        route: "invoice-descriptions-list",
        resource: 'settings_invoice_description',
        action: 'read',
      },
      {
        title: "收據單據備註管理",
        route: "receipt-document-descriptions-list",
        resource: 'settings_receipt_document_description',
        action: 'read',
      },
      {
        title: "報價單單據備註管理",
        route: "quotation-descriptions-list",
        resource: 'settings_quotation_description',
        action: 'read',
      },
      {
        title: "發票階段管理",
        route: "receipt-descriptions-list",
        resource: 'settings_receipt_description',
        action: 'read',
      },
      {
        title: "項目管理",
        route: "setting-project",
        // 使用函數進行動態權限檢查
        resource: () => {
          return dynamicAbilityCan('read', 'settings_project_stage') ||
                 dynamicAbilityCan('read', 'settings_project_status') ||
                 dynamicAbilityCan('read', 'settings_project_booking_stage') ||
                 dynamicAbilityCan('read', 'settings_project_document_type')||
                 dynamicAbilityCan('read', 'settings_project_comment_type')||
                 dynamicAbilityCan('read', 'settings_project_activitice_type')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      {
        title: "財務管理",
        route: "finance-statuses-list",
        // 使用函數進行動態權限檢查
        resource: () => {
          return dynamicAbilityCan('read', 'settings_finance_banks') ||
                 dynamicAbilityCan('read', 'settings_finance_claims') ||
                 dynamicAbilityCan('read', 'settings_finance_expenditures') ||
                 dynamicAbilityCan('read', 'settings_finance_prepayments')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      {
        title: "商品分類",
        route: "product-type-list",
        // 使用函數進行動態權限檢查
        resource: () => {
          return dynamicAbilityCan('read', 'settings_product_type') ||
                 dynamicAbilityCan('read', 'settings_product_unit') ||
                 dynamicAbilityCan('read', 'settings_product_status')
                 ? 'Auth' : 'XX';
        },
        action: 'read',
      },
      // {
      //   title: "單據格式",
      //   route: "receipt-format-list",
      //   resource:'setting-templates',
      //   action:'read',
      // },
      {
        title: "編號格式",
        route: "prefix",
        resource: 'settings_prefix',
        action: 'read',
      },
      // {
      //   title: "背景格式",
      //   route: "backgrounds-list",
      // },
    ],
  },
]; // 結束 getNormalMenuItems 函數

const worker = [
];

const customer = [
];

const supplier = [
]

// 處理動態 resource 函數的輔助函數
const processNavigationItems = (items) => {
  return items.map(item => {
    // 如果是群組項目，遞歸處理子項目
    if (item.children) {
      return {
        ...item,
        children: processNavigationItems(item.children)
      };
    }

    // 如果 resource 是函數，執行它獲取實際值
    if (typeof item.resource === 'function') {
      return {
        ...item,
        resource: item.resource()
      };
    }

    return item;
  });
};

const getNavigationData = () => {
  const userData = getUserData();

  // 獲取基礎選單並處理動態 resource
  const processedNormal = processNavigationItems(getNormalMenuItems());

  if (userData && userData.user_type_id === 2) {
    // 客戶
    var customerNav = JSON.parse(JSON.stringify(customer));
    customerNav.unshift({
      title: "客戶/訂單資料",
      route: "order-customer-view",
      icon: "HomeIcon",
      resource: 'projects',
      action: 'view_detail',
    });
    return [...customerNav, ...processedNormal];
  }
  if (userData && userData.user_type_id === 3) {
    // 供應商
    var supplierNav = JSON.parse(JSON.stringify(supplier));
    supplierNav.unshift({
      title: "供應商",
      route: "supplier-view",
      icon: "BriefcaseIcon",
      resource: 'Auth',
      action: 'read',
    });
    return [...supplierNav, ...processedNormal];
  } else if (userData && userData.user_type_id === 4) {
    // 工人
    var workerNav = JSON.parse(JSON.stringify(worker));
    workerNav.unshift({
      title: "師傅",
      route: { name: "worker-view", params: { id: userData.id } },
      icon: "UserIcon",
      resource: 'workers',
      action: 'view_detail',
    });
    return [...workerNav, ...processedNormal];
  } else {
    // 正常用戶
    return processedNormal;
  }
};

export default getNavigationData;